/** 系统自身的路由前缀 */
export const SYSTEM_ROUTE_PREFIXES = new Set(['system', 'pay'])
